import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "../Styles/Contact.css";

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    // Safely access the file input
    const fileInput = form.elements.attachments;
    if (fileInput) {
      const files = fileInput.files;

      // File Validation: Ensure all files are under 5MB
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 5 * 1024 * 1024) {
          alert("Each file must be under 5MB.");
          return;
        }
      }
    }

    // Optional Email Validation
    const email = form.email.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Optional Validation for Services (at least one must be selected)
    const services = form.querySelectorAll('input[name="services[]"]:checked');
    if (services.length === 0) {
      alert("Please select at least one service.");
      return;
    }

    // Submit the form (with file upload)
    form.submit();
  };

  return (
    <div>
      <Helmet>
        <meta
          name="description"
          content="Contact Piquota for inquiries or consultations."
        />
        <meta
          name="keywords"
          content="contact, business inquiries, project consultation, Piquota"
        />
        <meta name="author" content="Piquota" />
        <meta property="og:title" content="Contact Us | Piquota" />
        <meta
          property="og:description"
          content="Reach out to Piquota for your business needs."
        />
        <meta
          property="og:image"
          content="https://www.fatbit.com/media/banner-for-contact-us.jpg"
        />
        <meta property="og:url" content="https://www.piquota.com/contact" />
        <meta name="twitter:title" content="Contact Us | Piquota" />
        <meta
          name="twitter:description"
          content="Connect with Piquota for expert solutions."
        />
        <meta
          name="twitter:image"
          content="https://www.fatbit.com/media/banner-for-contact-us.jpg"
        />
      </Helmet>

      {/* Banner Section */}
      <div
        style={{
          position: "relative",
          backgroundImage: `url("Assets/Images/pexels-josh-hild-1270765-14449287.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "180px 0",
          color: "white",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          }}
        ></div>
        <Container
          className="text-left"
          style={{ position: "relative", zIndex: 2 }}
        >
          <h1
            className="banner-heading"
            style={{ fontSize: "2.5rem", fontWeight: "600" }}
          >
            Take the Next Step Today
          </h1>
          <p
            className="banner-paragraph"
            style={{ fontSize: "1.4rem", lineHeight: "1.8", color: "white" }}
          >
            Please fill the form, and our experts will guide you with the best solution.<br/> We’ll get in touch soon.
          </p>
        </Container>
      </div>

      <Container className="my-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <Form
              action="https://formsubmit.co/contact@piquota.com"
              method="POST"
              enctype="multipart/form-data"
              onSubmit={handleSubmit}
            >
              <Row className="mb-4">
                <Col md={4} className="d-flex align-items-top">
                  <h4 style={{ fontWeight: 400 }}>Basic Information</h4>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formName">
                    <Form.Label style={{ fontSize: "18px", fontWeight: "400" }}>
                      Name{" "}
                      <span style={{ color: "grey", fontSize: "12px" }}>
                        (required)
                      </span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="John Smith"
                      name="name"
                      required
                      style={{
                        border: "none",
                        borderBottom: "1px solid black",
                        borderRadius: "0px",
                        height: "50px",
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label style={{ fontSize: "18px", fontWeight: "400" }}>
                      Email{" "}
                      <span style={{ color: "grey", fontSize: "12px" }}>
                        (Required)
                      </span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="james.smith@company.com"
                      name="email"
                      required
                      style={{
                        border: "none",
                        borderBottom: "1px solid black",
                        borderRadius: "0px",
                        height: "50px",
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formPhone">
                    <Form.Label style={{ fontSize: "18px", fontWeight: "400" }}>
                      Phone Number{" "}
                      <span style={{ color: "grey", fontSize: "12px" }}>
                        (Required)
                      </span>
                    </Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder="+91 93483722947"
                      name="phone"
                      required
                      style={{
                        border: "none",
                        borderBottom: "1px solid black",
                        borderRadius: "0px",
                        height: "50px",
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <hr style={{ borderTop: "1px solid black", margin: "20px 0" }} />

              <Row className="mb-4">
                <Col md={4} className="d-flex align-items-top">
                  <h4 style={{ fontWeight: 400 }}>About Your Project</h4>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formMessage">
                    <Form.Label style={{ fontSize: "18px", fontWeight: "400" }}>
                      Message{" "}
                      <span style={{ color: "grey", fontSize: "12px" }}>
                        (Required)
                      </span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Describe your project"
                      name="message"
                      required
                      style={{
                        border: "none",
                        borderBottom: "1px solid black",
                        borderRadius: "0px",
                        height: "120px",
                      }}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Budget</Form.Label>
                    <div>
                      {[
                        "Above $50,000",
                        "From $20,000 - $50,000",
                        "From $5,000 - $10,000",
                        "From $1,000 - $2,500",
                      ].map((option, index) => (
                        <Form.Check
                          key={index}
                          type="radio"
                          label={option}
                          name="budget"
                          value={option}
                          required
                        />
                      ))}
                    </div>
                  </Form.Group>
                  <Form.Group controlId="formFileUpload">
                    <Form.Label>Upload Files</Form.Label>
                    <Form.Control type="file" name="attachments" multiple />
                  </Form.Group>
                </Col>
              </Row>

              <hr style={{ borderTop: "1px solid black", margin: "20px 0" }} />

              <Row className="mb-4">
                <Col md={4} className="d-flex align-items-top">
                  <h4 style={{ fontWeight: 400 }}>Services that Interest You</h4>
                </Col>
                <Col md={6}>
                  {[
                    "Piquota Products",
                    "Web design & Development",
                    "Mobile App Development",
                    "Custom eCommerce Solutions",
                    "Online Reputation Management",
                    "SEO & Marketing Services",
                    "Consultancy",
                    "Partnership",
                    "Other",
                  ].map((service, index) => (
                    <Form.Check
                      key={index}
                      type="checkbox"
                      label={service}
                      name="services[]"
                      value={service}
                    />
                  ))}
                </Col>
              </Row>

              <div style={{ textAlign: "right" }}>
                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  style={{ width: "200px", padding: "10px" }}
                >
                  Submit
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
